import React from 'react';
import PropTypes from 'prop-types';
import TreeView from 'components/common/TreeView';
import Spin from 'components/common/Spin';
import {connect} from 'react-redux';
import {index} from 'routes/Home/Attendance/Device/Module';

@connect((state) => ({
 // devices: state.Basic.Personnel.recruitmentDevices,
  devices: state.Attendance.Device.devices,
}), {
  indexDevices: index,
})
@autobind
/**
 *
 * @class ListWrapper
 * @extends PureComponent
 */
export default class ListWrapper extends React.PureComponent {
  static propDevices = {
    selected: PropTypes.arrayOf(
      PropTypes.string,
    ),
    onCheck: PropTypes.func,
    title: PropTypes.any,
    checkAll: PropTypes.bool,
    devices: PropTypes.arrayOf(PropTypes.object),
    indexDevices: PropTypes.func,
  };

  static defaultProps = {
    selected: [],
    onCheck: () => {
    },
    checkAll: true,
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      selected: props.selected,
    };
  }


  /**
   *
   */
  componentDidMount() {
    const {indexDevices} = this.props;

    indexDevices({}, (err) => !err && this.setState({loading: false}));
  }

  /**
   *
   * @return {Array}
   */
  selected() {
    return this.treeView.selected();
  }

  /**
   *
   * @param {Array} _selected
   * @private
   */
  _onCheck(_selected) {
    const {onCheck, devices} = this.props;
    const rules = devices;
    let selected = [];


    _selected.map((item) => {
      let _item = rules.find((_item) => _item.id === parseInt(item));
      if (_item && _item.rule) {
        selected.push(`${_item.name}`);
      }
    });

    this.setState({
      selected: _selected,
    });

    onCheck(_selected);
  }

  _renderItems(devices, deviceId) {
    let items = [];
    if (devices && devices[0]) {
      devices.map((device) => {
          items.push({id: device.id, title: device.name});
      });
    }

    // console.log(items);
    return items;
  }

  /**
   *permissions
   * @return {Array}
   * @private
   */
  _renderData(devices) {
    return this._renderItems(devices, null);
  }

  get _selected() {
    const {selected} = this.state;
    const rules = this.props.devices;
    let _selected = [];

    selected.map((item) => {
      let _item = rules.find((_item) => _item.id === parseInt(item));
      if (_item) {
        _selected.push(`${_item.id}`);
      }
    });

    return selected;
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {loading} = this.state;
    const {checkAll, title, devices} = this.props;

    return (

      <div
        style={{
          height: 'calc(300px)',
          overflow: 'auto',
        }}
      >
        <Spin
          spinning={loading}
          style={{
            height: '100%',
          }}
        >
          <TreeView
            checkable
            title={title}
            showSearch={false}
            onCheck={this._onCheck}
            treeData={this._renderData(devices)}
            defaultCheckedKeys={this._selected}
            checkAllButton={checkAll}
            treeStyle={{height: 'calc(100% - 44px)'}}
            ref={(input) => this.treeView = input}
          />
        </Spin>
      </div>
    );
  }
}
